import React from "react";
import { Button, Modal } from "react-bootstrap";

interface ConfirmationBoxProps {
    showConfirmBox: boolean;
    closeConfirmBox: () => void;
    performAction: () => void;
    title: string;
    message: string;
}

const ConfirmationBox: React.FC<ConfirmationBoxProps> = ({ showConfirmBox, closeConfirmBox, performAction, title, message }) => {
    return (
        <Modal show={showConfirmBox} onHide={closeConfirmBox} centered
            backdrop="static" // Prevents closing on outside click
            keyboard={false} // Prevents closing on pressing the "Escape" key
        >
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeConfirmBox}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={performAction}>
                    Confirm
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmationBox;